import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./shared";
import { CHAPTERS } from "../../lib/data";
import aboutImg from "../../assets/IMG_6077.jpg";

export const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section className="section" id="about" data-testid="about-section" ref={ref}>
      <div className="container">
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1.05fr", gap: 70, alignItems: "center" }} className="about-grid">
          <Reveal className="about-media"
            style={{ position: "relative", borderRadius: "var(--radius-lg)", overflow: "hidden",
              boxShadow: "var(--shadow-strong)", aspectRatio: "4/5" }}>
            <motion.img src={aboutImg} alt="Coach training a student in the VLA dojo"
              style={{ width: "100%", height: "116%", objectFit: "cover", y: imgY }} />
            <div style={{ position: "absolute", inset: 0, pointerEvents: "none",
              background: "radial-gradient(120% 90% at 30% 20%, transparent 40%, rgba(14,14,14,0.55) 100%)" }} />
            <div style={{ position: "absolute", bottom: 22, left: 22, right: 22, background: "rgba(14,14,14,0.72)",
              backdropFilter: "blur(10px)", border: "1px solid rgba(242,169,59,0.35)", borderRadius: "var(--radius-md)",
              padding: "18px 20px", color: "#fff" }}>
              <strong style={{ color: "var(--gold)", fontFamily: "'Bebas Neue'", fontSize: 24, display: "block" }}>
                Est. Discipline. Real Results.</strong>
              <span style={{ fontSize: 13, color: "rgba(255,255,255,0.78)" }}>A dojo built on respect, structure, and progress.</span>
            </div>
          </Reveal>

          <div>
            <Reveal><p className="eyebrow">About VLA</p></Reveal>
            <Reveal delay={0.05}>
              <h2 className="section-title" style={{ marginTop: 16 }}>
                Where <span className="accent">discipline</span> meets strength
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="section-sub">Victorious Lions Academy exists to build confident, disciplined, and physically strong individuals through martial arts and functional fitness — one class, one belt, one breakthrough at a time.</p>
            </Reveal>

            <div style={{ marginTop: 40, display: "grid", gap: 4 }}>
              {CHAPTERS.map((c, i) => (
                <Reveal key={c.n} delay={0.12 + i * 0.08}>
                  <div style={{ display: "grid", gridTemplateColumns: "auto 1fr", gap: 22, padding: "22px 0",
                    borderTop: "1px solid rgba(17,17,17,0.1)" }}>
                    <span style={{ fontFamily: "'Bebas Neue'", fontSize: 34, color: "var(--red)", lineHeight: 1 }}>{c.n}</span>
                    <div>
                      <h4 style={{ fontFamily: "'Inter'", fontWeight: 800, fontSize: 16, textTransform: "uppercase",
                        letterSpacing: "0.02em", color: "var(--black)", marginBottom: 6 }}>{c.title}</h4>
                      <p style={{ fontSize: 14.5, color: "var(--muted)" }}>{c.body}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
